export default __webpack_public_path__ + "static/media/pic56.9892375c.jpg";